export default {
    NAO_POSSUI: 1,
}